import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_KEYWORD,
  CHANGE_CHECKED_KEYWORDS_LANGUAGE,
  CHECK_MAIN_KEYWORD_NODES_FOR_TYPE,
  CLEAR_MAIN_KEYWORD_ERROR,
  DELETE_CHECKED_KEYWORDS,
  DELETE_KEYWORD,
  RENAME_KEYWORD,
  RESET_INGREDIENT_KEYWORDS,
  SET_DATA_FOR_RENAMING_KEYWORD,
} from '../action-types'

export const clearMainKeywordError = createAction(CLEAR_MAIN_KEYWORD_ERROR)
export const addKeywordNode = createPayloadAction(ADD_KEYWORD)
export const deleteKeywordNode = createPayloadAction(DELETE_KEYWORD)
export const renameKeywordNode = createPayloadAction(RENAME_KEYWORD)
export const resetIngredienKeywords = createAction(RESET_INGREDIENT_KEYWORDS)

export const checkMainKeywordNodesForType = createPayloadAction(
  CHECK_MAIN_KEYWORD_NODES_FOR_TYPE,
)

export const setDataForRenamingKeyword = createPayloadAction(
  SET_DATA_FOR_RENAMING_KEYWORD,
)

export const changeCheckedKeywordsLanguage = createPayloadAction(
  CHANGE_CHECKED_KEYWORDS_LANGUAGE,
)

export const deleteCheckedKeywords = createAction(DELETE_CHECKED_KEYWORDS)
